import script from "./small-image-tile.vue?vue&type=script&lang=js"
export * from "./small-image-tile.vue?vue&type=script&lang=js"

import "./small-image-tile.vue?vue&type=style&index=0&id=745a7ddc&lang=scss"

const __exports__ = script;

export default __exports__